<template>
    <div class="point-page" :style="{ height: tableHeight + 'px' }" v-loading="loading">
        <div class="content-wrapper">
            <div class="banner-card">
                <div class="banner-overlay"></div>
                <div class="banner-content">
                    <div class="banner-top">
                        <div class="banner-left">
                            <div class="unit-selector-btn" @click="goBack">
                                <i class="el-icon-s-unfold"></i>
                                <span class="btn-label">选择单元</span>
                            </div>
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="nav-breadcrumb">
                                <el-breadcrumb-item v-if="user.schoolName">{{ user.schoolName }}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{ currentSelectionTitle }}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                        <div class="banner-right">
                            <el-dropdown trigger="click" @command="openHandleClickMore">
                                <div class="user-capsule">
                                    <span class="user-avatar">
                                        <i class="el-icon-user"></i>
                                    </span>
                                    <span class="user-account">{{ maskedAccount }}</span>
                                    <i class="el-icon-arrow-down capsule-arrow"></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-unlock" command="view" disabled>有效期：{{
                                        user.expirationDate || '--'
                                        }}</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-switch-button" divided
                                        command="logout">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="banner-title">
                        <span class="banner-title-text">{{ unitTitle || currentSelectionTitle }}</span>
                    </div>
                </div>
            </div>

            <div class="main-card" v-loading="contentLoading">
                <div class="content-toolbar">
                    <div class="selection-badges">
                        <span class="selection-badge selection-badge--series">{{ currentSeriesName }}</span>
                        <span class="selection-badge selection-badge--level">{{ currentLevelName }}</span>
                        <span class="selection-badge selection-badge--unit">{{ currentUnitBadge }}</span>
                    </div>
                    <div class="resource-summary">{{ pointList.length }} 个点读资源</div>
                </div>

                <div v-if="!contentLoading && pointList.length === 0" class="empty-state">
                    <i class="el-icon-folder-opened empty-icon"></i>
                    <p class="empty-title">当前单元暂无点读内容</p>
                    <p class="empty-desc">可以切换册次、级别或单元看看别的资源。</p>
                    <el-button type="primary" size="small" round @click="goBack">重新选择单元</el-button>
                </div>

                <studyNew v-else class="point-study-host" :productList="pointList" :activeName="'7'" :isPoint="true"
                    :viewedCodes="[]"></studyNew>
            </div>
        </div>

        <el-drawer :direction="direction" :visible.sync="drawer" :with-header="false" :size="drawerSize"
            @opened="scrollToActiveUnit">
            <div class="drawer-container">
                <div class="drawer-header">
                    <span class="drawer-title">选择点读单元</span>
                    <div class="drawer-close" @click="drawer = false"><i class="el-icon-close"></i></div>
                </div>
                <div class="selection-path" v-if="selectionPath">
                    <i class="el-icon-location-outline"></i> {{ selectionPath }}
                </div>
                <div class="drawer-body">
                    <div class="filter-section">
                        <div class="filter-title">系列</div>
                        <div class="pill-group">
                            <button v-for="item in seriesList" :key="item.serievalue" class="pill-btn"
                                :class="{ 'pill-btn--active': item.serievalue === selectSeries }"
                                @click="handleSeriesChange(item.serievalue)">
                                {{ item.seriename }}
                            </button>
                        </div>
                    </div>

                    <div class="filter-section" v-if="midlles.length > 0">
                        <div class="filter-title">册次</div>
                        <div class="pill-group">
                            <button v-for="item in midlles" :key="item.value" class="pill-btn pill-btn--light"
                                :class="{ 'pill-btn--active': item.value === currentMidlle }"
                                @click="handleMiddleChange(item.value)">
                                {{ item.label }}
                            </button>
                        </div>
                    </div>

                    <div class="filter-section" v-if="currentLevel.length > 0">
                        <div class="filter-title">级别</div>
                        <div class="pill-group">
                            <button v-for="item in currentLevel"
                                :key="item.levelid || (item.levelname + '-' + item.levelvale)"
                                class="pill-btn pill-btn--light"
                                :class="{ 'pill-btn--active': item.levelvale === selectProductLevel }"
                                @click="handleLevelChange(item.levelvale)">
                                {{ item.levelname }}
                            </button>
                        </div>
                    </div>

                    <div class="filter-section filter-section--units">
                        <div class="filter-title">单元</div>
                        <div class="unit-grid">
                            <div v-for="item in unitList" :key="item.unitNo" class="unit-card"
                                :class="{ 'unit-card--active': item.unitNo === (selectUnit && selectUnit.unitNo) }"
                                @click="unitSelectImgHandle(item)">
                                <el-image class="unit-thumb" :src="item.unitThumbnail" :title="item.unitName">
                                    <div slot="error" class="image-slot">
                                        <img src="~@/assets/images/error.png" class="unit-thumb-error" />
                                    </div>
                                </el-image>
                                <div class="unit-name">{{ item.unitName || ('第' + item.unitNo + '单元') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import studyNew from '@/components/class/StudyNew.vue'
import api from '@/utils/api'
import auth from '@/utils/auth'

const HEARTBEAT_INTERVAL = 1000 * 30

export default {
    name: 'pointClass',
    components: {
        studyNew
    },
    data () {
        return {
            timer: null,
            loading: true,
            contentLoading: false,
            tableHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            drawer: false,
            direction: 'ltr',
            selectSeries: 0,
            selectProductLevel: 0,
            selectProductUnit: 0,
            selectUnit: null,
            unitTitle: '',
            user: {},
            seriesList: [],
            unitList: [],
            allProducts: [],
            pointList: [],
            midlles: [],
            currentMidlle: 0,
            currentLevel: []
        }
    },
    computed: {
        drawerSize () {
            if (this.windowWidth >= 1024) return '430px'
            if (this.windowWidth >= 768) return '65%'
            return '86%'
        },
        currentSeries () {
            return this.seriesList.find(item => item.serievalue === this.selectSeries) || this.seriesList[0] || null
        },
        currentMiddle () {
            const middles = this.currentSeries && Array.isArray(this.currentSeries.middles)
                ? this.currentSeries.middles
                : []
            return middles.find(item => item.value === this.currentMidlle) || middles[0] || null
        },
        currentLevelItem () {
            const levels = this.currentMiddle && Array.isArray(this.currentMiddle.levellist)
                ? this.currentMiddle.levellist
                : []
            return levels.find(item => item.levelvale === this.selectProductLevel) || levels[0] || null
        },
        currentSeriesName () {
            return this.currentSeries ? this.currentSeries.seriename : '未选择系列'
        },
        currentMiddleLabel () {
            return this.currentMiddle ? this.currentMiddle.label : '未选择册次'
        },
        currentLevelName () {
            return this.currentLevelItem ? this.currentLevelItem.levelname : '未选择级别'
        },
        currentUnitBadge () {
            if (this.selectUnit && this.selectUnit.unitNo) {
                return this.formatUnitBadge(this.selectUnit.unitNo)
            }
            const match = (this.currentUnitName || '').match(/第.{1,3}单元/)
            return match ? match[0] : this.currentUnitName
        },
        currentUnitName () {
            if (!this.selectUnit) return this.unitTitle || '未选择单元'
            return this.selectUnit.productName || this.selectUnit.unitName || ('第' + this.selectUnit.unitNo + '单元')
        },
        currentSelectionTitle () {
            return this.currentUnitName
        },
        selectionPath () {
            return [
                this.currentSeriesName,
                this.currentMiddleLabel,
                this.currentLevelName,
                this.currentUnitName
            ].filter(Boolean).join(' / ')
        },
        maskedAccount () {
            const account = this.user.account || ''
            if (account.length >= 7) {
                return account.substring(0, 3) + '****' + account.substring(account.length - 4)
            }
            return account
        }
    },
    created () {
        this.validate()
    },
    mounted () {
        window.addEventListener('resize', this.handleResize)
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },
    beforeDestroy () {
        clearInterval(this.timer)
        window.removeEventListener('resize', this.handleResize)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
    methods: {
        handleResize () {
            this.tableHeight = window.innerHeight
            this.windowWidth = window.innerWidth
        },
        handleVisibilityChange () {
            if (document.hidden) {
                clearInterval(this.timer)
                return
            }
            this.auth()
            this.startHeartbeat()
        },
        startHeartbeat () {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.auth()
            }, HEARTBEAT_INTERVAL)
        },
        handleApiError (message = '网络异常，请稍后重试') {
            this.$message({
                message,
                type: 'error'
            })
        },
        formatChineseNumber (value) {
            const number = Number(value)
            if (!Number.isFinite(number) || number <= 0) {
                return String(value || '')
            }

            const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
            if (number < 10) {
                return digits[number]
            }
            if (number === 10) {
                return '十'
            }
            if (number < 20) {
                return '十' + digits[number % 10]
            }
            if (number < 100) {
                const tens = Math.floor(number / 10)
                const ones = number % 10
                return digits[tens] + '十' + (ones ? digits[ones] : '')
            }
            return String(value)
        },
        formatUnitBadge (unitNo) {
            return '第' + this.formatChineseNumber(unitNo) + '单元'
        },
        getSeriesValue (series) {
            if (series && typeof series.serievalue !== 'undefined' && series.serievalue !== null) {
                return series.serievalue
            }

            const serieId = ((series && series.serieid) || this.$route.query.serial || '').toString()
            if (serieId === '168') {
                return 1
            }
            if (serieId === '128') {
                return 2
            }
            return 0
        },
        getLevelBookOrder (level) {
            const name = (level && level.levelname) || ''
            const bookMatch = name.match(/^第([一二三四五六七八])册$/)
            if (bookMatch) {
                const mapping = {
                    一: 1,
                    二: 2,
                    三: 3,
                    四: 4,
                    五: 5,
                    六: 6,
                    七: 7,
                    八: 8
                }
                return mapping[bookMatch[1]] || null
            }

            const levelMapping = {
                预备级: 1,
                第一级: 2,
                第二级: 3,
                第三级: 4
            }
            return Object.prototype.hasOwnProperty.call(levelMapping, name) ? levelMapping[name] : null
        },
        normalizeMiddleLevels (levels, middle) {
            if (!Array.isArray(levels)) {
                return []
            }

            const isFrontBooks = middle && middle.label === '前四册'
            const isBackBooks = middle && middle.label === '后四册'
            const dedupe = new Set()

            return levels
                .filter(level => level)
                .filter(level => {
                    const order = this.getLevelBookOrder(level)
                    if (order === null) return true
                    if (isFrontBooks) return order >= 1 && order <= 4
                    if (isBackBooks) return order >= 5 && order <= 8
                    return true
                })
                .sort((left, right) => {
                    const leftOrder = this.getLevelBookOrder(left)
                    const rightOrder = this.getLevelBookOrder(right)

                    if (leftOrder !== null && rightOrder !== null && leftOrder !== rightOrder) {
                        return leftOrder - rightOrder
                    }
                    return (left.levelvale || 0) - (right.levelvale || 0)
                })
                .filter(level => {
                    const key = [level.levelid, level.levelname, level.levelvale].join('|')
                    if (dedupe.has(key)) {
                        return false
                    }
                    dedupe.add(key)
                    return true
                })
        },
        normalizeSeriesList (seriesList) {
            if (!Array.isArray(seriesList)) {
                return []
            }

            return seriesList
                .filter(item => item)
                .map(item => {
                    const rawMiddles = Array.isArray(item.middles)
                        ? item.middles
                        : (Array.isArray(item.Middles) ? item.Middles : [])
                    const rawLevels = Array.isArray(item.levellist)
                        ? item.levellist
                        : (Array.isArray(item.LevelList) ? item.LevelList : [])
                    const middles = rawMiddles.length > 0
                        ? rawMiddles
                        : (rawLevels.length > 0
                            ? [{ value: 0, label: '全部', levellist: rawLevels }]
                            : [])

                    const normalizedMiddles = middles
                        .filter(middle => middle)
                        .map(middle => ({
                            ...middle,
                            levellist: this.normalizeMiddleLevels(
                                Array.isArray(middle.levellist)
                                    ? middle.levellist
                                    : (Array.isArray(middle.LevelList) ? middle.LevelList : []),
                                middle
                            )
                        }))
                        .filter(middle => middle.levellist.length > 0)

                    return {
                        ...item,
                        serievalue: this.getSeriesValue(item),
                        middles: normalizedMiddles
                    }
                })
                .filter(item => item.middles.length > 0)
        },
        setSeriesContext (seriesValue) {
            const series = this.seriesList.find(item => item.serievalue === seriesValue) || this.seriesList[0] || null
            if (!series) {
                this.selectSeries = 0
                this.midlles = []
                this.currentMidlle = 0
                this.currentLevel = []
                this.selectProductLevel = 0
                return
            }

            this.selectSeries = series.serievalue
            this.midlles = Array.isArray(series.middles) ? series.middles : []
            this.setMiddleContext(this.midlles[0] ? this.midlles[0].value : 0)
        },
        setMiddleContext (middleValue) {
            const middle = this.midlles.find(item => item.value === middleValue) || this.midlles[0] || null
            if (!middle) {
                this.currentMidlle = 0
                this.currentLevel = []
                this.selectProductLevel = 0
                return
            }

            this.currentMidlle = middle.value
            this.currentLevel = Array.isArray(middle.levellist) ? middle.levellist : []
            this.selectProductLevel = this.currentLevel[0] ? this.currentLevel[0].levelvale : 0
        },
        async validate () {
            try {
                const res = await this.$axios.post(api.validateCode, {
                    key: this.$route.query.token,
                    type: this.$route.query.serial,
                    catalog: Number(this.$route.query.catalog || 0)
                })
                const result = (res && res.data && res.data.result) || {}
                const seriesList = this.normalizeSeriesList(result.serieslist)
                console.log('[point.validate] result:', result)

                if (result.state !== 'success') {
                    auth.clearToken()
                    this.$alert(result.info || '授权校验失败', '登录异常', {
                        confirmButtonText: '确定',
                        callback: () => {
                            window.location.href = '/assets/index.html#/login'
                        }
                    })
                    return
                }

                auth.clearToken()
                auth.setToken(result.info)

                if (seriesList.length === 0) {
                    this.$alert(result.info || '授权验证成功，但没有返回可用级别列表', '提示', {
                        confirmButtonText: '确定'
                    })
                    return
                }

                this.seriesList = seriesList
                this.setSeriesContext(seriesList[0].serievalue)

                await this.getUser()
                await this.refreshContent(true)
                this.startHeartbeat()
            } catch (error) {
                console.error('[point.validate] failed:', error)
                auth.clearToken()
                this.$alert('授权校验失败，请稍后重试', '提示', {
                    confirmButtonText: '确定'
                })
            } finally {
                this.loading = false
            }
        },
        async getUser () {
            try {
                const res = await this.$axios.post(api.getUserInfo)
                this.user = (res && res.data && res.data.result) || {}
            } catch (error) {
                console.error('[point.getUser] failed:', error)
            }
        },
        async getUnits () {
            const res = await this.$axios.get(api.getProductUnits(this.selectSeries, this.selectProductLevel))
            this.unitList = Array.isArray(res.data.result) ? res.data.result : []
            let selected = this.unitList.find(item => item.unitNo === this.selectProductUnit) || null
            if (!selected && this.unitList.length > 0) {
                selected = this.unitList[0]
            }
            this.selectUnit = selected
            this.selectProductUnit = selected ? selected.unitNo : 0
        },
        async query () {
            if (!this.selectProductUnit) {
                this.allProducts = []
                this.pointList = []
                this.unitTitle = ''
                return
            }

            const partsPromise = this.$axios.post(api.getProductParts, {
                PageIndex: 1,
                Series: this.selectSeries,
                Level: this.selectProductLevel,
                ProductUnit: this.selectProductUnit,
                PageSize: 100
            })
            const titlePromise = this.$axios.get(api.getUnitTitle(this.selectSeries, this.selectProductLevel, this.selectProductUnit))
            const [partsRes, titleRes] = await Promise.all([partsPromise, titlePromise])

            const items = partsRes && partsRes.data && partsRes.data.result && Array.isArray(partsRes.data.result.items)
                ? partsRes.data.result.items
                : []
            this.allProducts = items.map(item => ({
                ...item,
                previewurl: [item.sourceUrl]
            }))
            this.pointList = this.allProducts.filter(item => String(item.courseType) === '7')
            this.unitTitle = titleRes && titleRes.data && titleRes.data.result
                ? titleRes.data.result.unitTitle
                : ''
        },
        async refreshContent (resetUnit) {
            this.contentLoading = true
            if (resetUnit) {
                this.selectProductUnit = 0
                this.selectUnit = null
            }

            try {
                await this.getUnits()
                await this.query()
            } catch (error) {
                console.error('[point.refreshContent] failed:', error)
                this.handleApiError()
            } finally {
                this.contentLoading = false
            }
        },
        async handleSeriesChange (seriesValue) {
            if (seriesValue === this.selectSeries) return
            this.setSeriesContext(seriesValue)
            await this.refreshContent(true)
        },
        async handleMiddleChange (middleValue) {
            if (middleValue === this.currentMidlle) return
            this.setMiddleContext(middleValue)
            await this.refreshContent(true)
        },
        async handleLevelChange (levelValue) {
            if (levelValue === this.selectProductLevel) return
            this.selectProductLevel = levelValue
            await this.refreshContent(true)
        },
        async unitSelectImgHandle (item) {
            this.selectProductUnit = item.unitNo
            this.selectUnit = item
            if (this.windowWidth <= 768) {
                this.drawer = false
            }
            await this.refreshContent(false)
        },
        goBack () {
            this.drawer = true
        },
        scrollToActiveUnit () {
            this.$nextTick(() => {
                const active = this.$el.querySelector('.unit-card--active')
                if (active) {
                    active.scrollIntoView({ behavior: 'smooth', block: 'center' })
                }
            })
        },
        auth () {
            this.$axios.post(api.authCheck)
                .then(res => {
                    if (res.data.result !== 1) {
                        const content = res.data.result === 0 ? '登录身份失效，请重新登录' : '登录人数过多'
                        this.$alert(content, '登录异常', {
                            confirmButtonText: '确定',
                            callback: () => {
                                window.location.href = '/assets/index.html#/login'
                            }
                        })
                    }
                })
                .catch(() => { })
        },
        openHandleClickMore (command) {
            if (command !== 'logout') return
            this.$confirm('确定退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(api.logout)
                    .then(() => {
                        auth.clearToken()
                        window.location.href = '/'
                    })
            }).catch(() => { })
        }
    }
}
</script>

<style scoped lang="scss">
.point-page {
    background: linear-gradient(135deg, #eef7ff 0%, #dcefff 45%, #f8fbff 100%);
    touch-action: manipulation;
    overflow: hidden;
}

.content-wrapper {
    width: 78%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 18px 0;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.banner-card {
    position: relative;
    background-image: url('~@/assets/images/banner-edu.jpg');
    background-size: cover;
    background-position: center;
    height: 118px;
    border-radius: 12px 12px 0 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.10);
    overflow: hidden;
}

.banner-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.90) 0%, rgba(105, 187, 255, 0.86) 100%);
}

.banner-content {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.banner-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 48px;
}

.banner-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
}

.unit-selector-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    font-size: 20px;
    font-weight: 700;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

    &:hover {
        background: rgba(255, 255, 255, 0.15);
    }
}

.btn-label {
    font-size: 14px;
    font-weight: 600;
}

.nav-breadcrumb {
    line-height: 1;
    min-width: 0;
    overflow: hidden;
}

::v-deep .el-breadcrumb__separator,
::v-deep .el-breadcrumb__inner {
    color: #fff;
    font-size: 15px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__separator {
    color: #fff;
}

.banner-right {
    display: flex;
    align-items: center;
    padding-left: 16px;
    flex-shrink: 0;
}

.user-capsule {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 14px 5px 5px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.4);
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }
}

.user-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.35);
    color: #fff;
    font-size: 14px;
    flex-shrink: 0;
}

.user-account {
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    letter-spacing: 0.3px;
}

.capsule-arrow {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
}

.banner-title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px 12px;
}

.banner-title-text {
    color: #fff;
    font-size: 2em;
    font-weight: 800;
    letter-spacing: 1.4px;
    text-align: center;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.main-card {
    flex: 1;
    min-height: 0;
    border-radius: 0 0 12px 12px;
    border: 1px solid #e5eef8;
    border-top: none;
    background: #fff;
    box-shadow: 0 14px 30px rgba(112, 144, 176, 0.12);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.content-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 20px 10px;
    border-bottom: 1px solid #edf3fa;
    background: linear-gradient(180deg, rgba(248, 251, 255, 0.96) 0%, rgba(255, 255, 255, 1) 100%);
    flex-shrink: 0;
}

.selection-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.selection-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 34px;
    padding: 0 14px;
    border-radius: 14px;
    background: #f6f9fd;
    color: #5d748f;
    font-size: 14px;
    font-weight: 700;
    border: 1px solid #e2ebf5;
    box-sizing: border-box;
}

.selection-badge--series {
    background: #edf6ff;
    color: #3d7fd9;
    border-color: #d6e8fb;
}

.selection-badge--level {
    background: #f7fbff;
    color: #6f8fb8;
}

.selection-badge--unit {
    min-height: 40px;
    padding: 0 16px;
    border-radius: 4px;
    background: #fff;
    color: #29a0fb;
    border: 2px solid #29a0fb;
    font-size: 28px;
    letter-spacing: 0.5px;
}

.resource-summary {
    color: #6b7a90;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
}

.point-study-host {
    flex: 1;
    min-height: 0;
    display: flex;
}

::v-deep .point-study-host .study-root {
    flex: 1;
    min-height: 0;
}

.empty-state {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 24px;
    text-align: center;
}

.empty-icon {
    font-size: 52px;
    color: #b4c8dd;
}

.empty-title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: #35475f;
}

.empty-desc {
    margin: 0 0 6px;
    font-size: 13px;
    color: #7b8da3;
}

::v-deep .el-drawer__body {
    height: 100%;
    overflow: hidden;
}

.drawer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background: #fff;
}

.drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: linear-gradient(135deg, #f5fbff 0%, #e7f3ff 100%);
    border-bottom: 1px solid #e6eef7;
    flex-shrink: 0;
}

.drawer-title {
    color: #2f4a67;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.3px;
}

.drawer-close {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #6d7f92;
    cursor: pointer;
    font-size: 18px;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(64, 158, 255, 0.08);
        color: #409eff;
    }
}

.selection-path {
    margin: 12px 16px 0;
    padding: 10px 14px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f6fbff 0%, #eff7ff 100%);
    border: 1px solid #dcecff;
    color: #3d7fd9;
    font-size: 13px;
    font-weight: 500;
    flex-shrink: 0;

    i {
        margin-right: 6px;
    }
}

.drawer-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0 16px 20px;
}

.drawer-body::-webkit-scrollbar {
    width: 6px;
}

.drawer-body::-webkit-scrollbar-track {
    background: transparent;
}

.drawer-body::-webkit-scrollbar-thumb {
    background: rgba(140, 164, 192, 0.55);
    border-radius: 3px;
}

.filter-section {
    padding-top: 16px;
}

.filter-section--units {
    padding-bottom: 16px;
}

.filter-title {
    margin-bottom: 10px;
    color: #4a5d76;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.2px;
}

.pill-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.pill-btn {
    border: 1px solid #d7e7f7;
    background: #eef6ff;
    color: #3c6fba;
    border-radius: 999px;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(64, 158, 255, 0.12);
    }
}

.pill-btn--light {
    background: #f8fbff;
    color: #5c6f86;
}

.pill-btn--active {
    background: linear-gradient(135deg, #409eff 0%, #67b4ff 100%);
    border-color: #409eff;
    color: #fff;
    box-shadow: 0 8px 18px rgba(64, 158, 255, 0.22);
}

.unit-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 4px 0 0;
}

.unit-card {
    width: calc(50% - 6px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border-radius: 12px;
    border: 2px solid transparent;
    background: #fbfdff;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 22px rgba(64, 158, 255, 0.12);
        background: #f4f9ff;
    }
}

.unit-card--active {
    border-color: #409eff;
    background: #edf6ff;
    box-shadow: 0 12px 22px rgba(64, 158, 255, 0.18);
}

.unit-thumb,
.unit-thumb-error {
    width: 100%;
    aspect-ratio: 4 / 3;
    border-radius: 10px;
    overflow: hidden;
    object-fit: cover;
}

.unit-name {
    width: 100%;
    margin-top: 8px;
    color: #4d6179;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (max-width: 1440px) {
    .content-wrapper {
        width: 90%;
    }
}

@media (max-width: 1024px) {
    .content-wrapper {
        width: 95%;
        padding-top: 6px;
    }

    .banner-card {
        height: 88px;
        border-radius: 8px 8px 0 0;
    }

    .banner-top {
        height: 40px;
        padding: 0 14px;
    }

    .banner-title-text {
        font-size: 1.35em;
    }

    .main-card {
        border-radius: 0 0 8px 8px;
    }
}

@media (max-width: 768px) {
    .content-wrapper {
        width: 100%;
        padding: 0;
    }

    .banner-card {
        height: 80px;
        border-radius: 0;
        box-shadow: none;
    }

    .banner-top {
        height: 32px;
        padding: 0 12px;
    }

    .unit-selector-btn {
        font-size: 16px;
        padding: 2px 6px;
    }

    .btn-label,
    .nav-breadcrumb {
        display: none;
    }

    .user-capsule {
        padding: 3px 10px 3px 3px;
        gap: 5px;
    }

    .user-avatar {
        width: 24px;
        height: 24px;
        font-size: 12px;
    }

    .user-account {
        font-size: 12px;
    }

    .banner-title {
        padding: 0 12px 10px;
    }

    .banner-title-text {
        font-size: 1.12em;
        letter-spacing: 0.4px;
    }

    .main-card {
        border-radius: 0;
        border: none;
        box-shadow: none;
    }

    .content-toolbar {
        padding: 12px 12px 8px;
        align-items: flex-start;
        flex-direction: column;
    }

    .selection-badges {
        gap: 6px;
    }

    .selection-badge {
        min-height: 32px;
        padding: 0 12px;
        border-radius: 12px;
        font-size: 13px;
    }

    .selection-badge--unit {
        min-height: 38px;
        padding: 0 14px;
        font-size: 20px;
    }

    .resource-summary {
        font-size: 12px;
    }

    .drawer-header {
        padding: 12px 14px;
    }

    .drawer-body {
        padding: 0 12px 18px;
    }

    .unit-grid {
        gap: 8px;
    }

    .unit-card {
        width: calc(50% - 4px);
        padding: 6px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/point/class.vue